import React, { useEffect, useState } from 'react';
import './MonthlyReport.css';

const MonthlyReport = () => {
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('e');
    const i = params.get("i") || ""
    if (!email) {
      return;
    }
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    
    const url = `${baseUrl}engagement/monthly-report?e=${encodeURIComponent(email)}&i=${encodeURIComponent(i)}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        if (data && data.report_json) {
          setReportData(data.report_json);
        }
      })
      .catch(() => {
        setReportData(null);
      });
  }, []);

  const summary = reportData?.summary?.overall_analysis;
  const responseRate = reportData?.participation_percentage ?? 0;
  const averageScore = reportData?.avg_response_rating ?? 0;
  const averageScoreDisplay = Number(averageScore).toFixed(1);

  return (
    <div className="mg-monthly-report-body">
      {!reportData && (
        <div className="mg-monthly-loading">Please wait...</div>
      )}
      <div className="mg-monthly-report-container">
        <h2 className="mg-monthly-title">
          Thank you for taking the time to participate in our 6 daily question program.
        </h2>
        {reportData && (
          <div id="summary-report" className="mg-monthly-summary">
            <div className="mg-monthly-metric-card">
              <div className="mg-monthly-metric-value">{responseRate}</div>
              <div className="mg-monthly-metric-label">Avg. Response Rate</div>
            </div>
            <div className="mg-monthly-metric-card">
              <div className="mg-monthly-metric-value">{averageScoreDisplay}</div>
              <div className="mg-monthly-metric-label">Overall Avg. Score</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthlyReport;
